import React, { useState, useEffect } from 'react';
import Growth from '../../assets/image/png/Market Growth.png';
import Growth1 from '../../assets/image/png/Growth.png';
import Quality from '../../assets/image/png/Quaility.png';
import Top from '../../assets/image/png/Top.png';
import Navbar from '../homepage/Navbar';
import {Footer} from "../../shared";
import EnlistYourInstitute from '../trainingCourse/EnlistYourInstitute';

const App = () => {
  
  const [selectedPackage, setSelectedPackage] = useState(null);
const [billingCycle, setBillingCycle] = useState("annually");

  const pricing = {
 pro: billingCycle === "annually" ? 699 : 999,
premium: billingCycle === "annually" ? 2099 : 2999,
enterprise: billingCycle === "annually" ? 2799 : 3999,

  };

  const plans = [
    {
      title: "Pro",
      price: pricing.pro,
      features: [
        "100 leads /month",
        "20-30 Students",
        "Access to community support",
        "Basic profile listing",
        "Email insights & analytics",
        "Support response within 48 hours",
      ],
    },
    {
      title: "Premium",
      price: pricing.premium,
      popular: true,
      features: [
        "200 leads /month",
        "30-40 Students",
        "Priority email & call support",
        "Premium placement in listings",
        "Detailed performance analytics",
        "Lead scoring & filters",
        "Support response within 12 hours",
      ],
    },
    {
      title: "Enterprise",
      price: pricing.enterprise,
      features: [
        "350 leads /month",
        "40-50 Students",
        "Dedicated account manager",
        "Custom integrations",
        "Advanced analytics dashboard",
        "Full profile customization",
        "Support response within 4 hours",
      ],
    },
  ];
useEffect(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);

  const handlePackageSelect = (packageName) => {
    setSelectedPackage(packageName);
  };
; 
  return (
    <>
    < Navbar />
   <div className="min-h-screen bg-white text-gray-800">
      {/* Hero Section */}
      <div className="relative h-[500px] w-full overflow-hidden">
  <div className="absolute inset-0 z-10"></div>

  <img
    src={Top}
    alt="Drone Training"
    className="absolute inset-0 w-full h-full object-cover object-top"
  />

  <div className="relative z-20 container mx-auto px-6 h-full flex flex-col justify-center -mt-4">
  <div className="max-w-2xl">
    <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
      Empower Your RPTO Growth with Consistent, High-Quality Student Leads
    </h1>
    <p className="text-lg md:text-xl text-white/90 mb-6">
      Tap into a powerful nationwide market pipeline for reliable,
      pre-qualified leads every month.
    </p>
<div className="flex flex-col items-start space-y-2">
  <button
    onClick={() =>
      document.getElementById("enlist-section")?.scrollIntoView({ behavior: "smooth" })
    }
    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-medium transition"
  >
    Get Started
  </button>
 <p className="text-sm text-white font-semibold">
    Claim your first 5 leads free!
  </p></div>


  </div>
</div>

</div>


      {/* Why Choose Our Subscription Section */}
 <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-20">
  <h2 className="text-2xl sm:text-4xl font-bold text-center text-blue-700 mb-10 sm:mb-16">
    Why Choose Our Subscription?
  </h2>

  {/* Grid Layout */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-10 mb-10 sm:mb-12">

    {/* Card 1 */}
    <div className="rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300">
      {/* Mobile view */}
      <div className="sm:hidden">
        <img src={Growth} alt="Market Expertise" className="w-full h-48 object-cover rounded-t-xl" />
        <div className="bg-white p-4 rounded-b-xl">
          <h3 className="text-base font-semibold text-gray-900 mb-1">Market Expertise & Precision</h3>
          <p className="text-sm text-gray-700 leading-relaxed">
               Access our specialized network of drone enthusiasts and career-seekers. We leverage advanced targeting algorithms to connect you with students who match your program's specific requirements.
          </p>
        </div>
      </div>

      {/* Desktop view */}
      <div className="hidden sm:block relative group rounded-xl overflow-hidden h-72 sm:h-auto">
        <img src={Growth} alt="Market Expertise" className="w-full h-full object-cover object-center" />
        <div className="absolute inset-x-4 bottom-4 bg-white bg-opacity-95 rounded-xl p-6 transition-all duration-300 group-hover:translate-y-[-4px]">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Market Expertise & Precision</h3>
          <p className="text-sm text-gray-700 leading-relaxed">
               Access our specialized network of drone enthusiasts and career-seekers. We leverage advanced targeting algorithms to connect you with students who match your program's specific requirements.
          </p>
        </div>
      </div>
    </div>

    {/* Repeat for Card 2 with Growth1 */}
    <div className="rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300">
      <div className="sm:hidden">
        <img src={Growth1} alt="Scalable Growth" className="w-full h-48 object-cover rounded-t-xl" />
        <div className="bg-white p-4 rounded-b-xl">
          <h3 className="text-base font-semibold text-gray-900 mb-1">Predictable, Scalable Growth</h3>
          <p className="text-sm text-gray-700 leading-relaxed">
  Maintain consistent enrollment numbers with our monthly lead delivery system. Scale your operations confidently with a reliable pipeline of qualified candidates interested in your RPTO programs.          </p>
        </div>
      </div>
      <div className="hidden sm:block relative group rounded-xl overflow-hidden h-72 sm:h-auto">
        <img src={Growth1} alt="Scalable Growth" className="w-full h-full object-cover object-center" />
        <div className="absolute inset-x-4 bottom-4 bg-white bg-opacity-95 rounded-xl p-6 transition-all duration-300 group-hover:translate-y-[-4px]">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Predictable, Scalable Growth</h3>
          <p className="text-sm text-gray-700 leading-relaxed">
  Maintain consistent enrollment numbers with our monthly lead delivery system. Scale your operations confidently with a reliable pipeline of qualified candidates interested in your RPTO programs.          </p>
        </div>
      </div>
    </div>
  </div>

  {/* Full-Width Card */}
  <div className="rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300">
    {/* Mobile */}
    <div className="sm:hidden">
      <img src={Quality} alt="Quality Assurance" className="w-full h-52 object-cover rounded-t-xl" />
      <div className="bg-white p-4 rounded-b-xl">
        <h3 className="text-base font-semibold text-gray-900 mb-1">Quality Assurance</h3>
        <p className="text-sm text-gray-700 leading-relaxed">
  All leads undergo our rigorous verification process to ensure genuine interest and basic qualifications. Our quality standards mean you spend less time filtering and more time converting quality prospects into students.        </p>
      </div>
    </div>

    {/* Desktop */}
    <div className="hidden sm:block relative group rounded-xl overflow-hidden h-80 sm:h-96">
      <img src={Quality} alt="Quality Assurance" className="w-full h-full object-cover object-center" />
      <div className="absolute inset-x-4 bottom-4 bg-white bg-opacity-95 rounded-xl p-6 transition-all duration-300 group-hover:translate-y-[-4px]">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Quality Assurance</h3>
        <p className="text-sm text-gray-700 leading-relaxed">
  All leads undergo our rigorous verification process to ensure genuine interest and basic qualifications. Our quality standards mean you spend less time filtering and more time converting quality prospects into students.        </p>
      </div>
    </div>
  </div>
</div>





      {/* Pricing Section */}
{/* Pricing Section */}
<div className="bg-gray-50 mt-[-48px] sm:mt-[-44px]">
  <div className="">

    {/* How It Works - Small Heading With Border */}
  <div className="bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 rounded-xl shadow-md">
  {/* How It Works Label */}
  <div className="flex justify-center mb-4">
    <span className="text-xs uppercase tracking-wider text-blue-600 font-semibold bg-blue-100 px-4 py-1 rounded-full">
      How It Works
    </span>
  </div>

  {/* Title */}
  <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-800 mb-10">
    Select Your Package
  </h2>

  {/* Steps */}
<div className="flex flex-col items-center max-w-5xl mx-auto px-4">
  <div className="flex flex-col sm:flex-row justify-between w-full relative mb-12 gap-8">
    {/* Step Line - Only visible on sm and above */}
    <div className="hidden sm:block absolute top-6 left-0 right-0 h-0.5 bg-gray-300 z-0" />

    {/* Step 1 */}
    <div className="flex flex-col items-center z-10 w-full sm:w-1/3 text-center px-4">
      <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-600 text-white text-lg font-bold">
        1
      </div>
      <h4 className="mt-5 text-base font-semibold text-gray-800">Define Your Target Profile</h4>
      <p className="text-sm text-gray-600 mt-2 leading-relaxed">
        We align on demographics, region, certification type, and budget range to ensure high intent leads.
      </p>
    </div>

    {/* Step 2 */}
    <div className="flex flex-col items-center z-10 w-full sm:w-1/3 text-center px-4">
      <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-600 text-white text-lg font-bold">
        2
      </div>
      <h4 className="mt-5 text-base font-semibold text-gray-800">Receive & Review Leads</h4>
      <p className="text-sm text-gray-600 mt-2 leading-relaxed">
        Leads are delivered directly in your dashboard — review and take action within 48 hours.
      </p>
    </div>

    {/* Step 3 */}
    <div className="flex flex-col items-center z-10 w-full sm:w-1/3 text-center px-4">
      <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-600 text-white text-lg font-bold">
        3
      </div>
      <h4 className="mt-5 text-base font-semibold text-gray-800">Engage & Convert</h4>
      <p className="text-sm text-gray-600 mt-2 leading-relaxed">
        Access proven email templates, call scripts, and follow-up cadences that boost conversion by up to 30%.
      </p>
    </div>
  </div>
</div>


</div>
  

    {/* Subscription Cards */}


<div className="max-w-6xl mx-auto px-4 py-14">
  {/* Billing Toggle */}
  <div className="flex justify-center mb-10">
 <div className="flex space-x-3">
  <button
    type="button"
    onClick={() => setBillingCycle("monthly")}
    className={`px-3 py-1.5 text-sm font-medium transition rounded ${
      billingCycle === "monthly"
        ? "bg-blue-600 text-white"
        : "bg-transparent text-gray-700 hover:bg-gray-100"
    }`}
  >
    Monthly
  </button>
  <button
    type="button"
    onClick={() => setBillingCycle("annually")}
    className={`px-3 py-1.5 text-sm font-medium transition rounded ${
      billingCycle === "annually"
        ? "bg-blue-600 text-white"
        : "bg-transparent text-gray-700 hover:bg-gray-100"
    }`}
  >
    Annually
    <span
      className={`text-xs font-bold ml-1 ${
        billingCycle === "annually" ? "text-white" : "text-blue-600"
      }`}
    >
      (30% OFF)
    </span>
  </button>
</div>


  </div>

  {/* Pricing Cards */}
  <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
    {plans.map((plan, index) => (
      <div
        key={index}
        className={`bg-white rounded-xl shadow-md overflow-hidden relative transition-all duration-300 ${
          plan.popular ? "ring-2 ring-blue-600" : "border border-gray-200"
        }`}
      >
        {plan.popular && (
          <span className="absolute top-2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-blue-600 text-white text-xs font-semibold px-3 py-1 rounded-full">
            Most popular
          </span>
        )}
        <div className="p-6 border-b">
          <h3 className="text-lg font-bold mb-1">{plan.title}</h3>
          <div className="flex items-end gap-1 mb-4">
            <span className="text-3xl font-bold">₹{plan.price}</span>
            <span className="text-gray-500 text-sm">/month</span>
          </div>
          <button
            onClick={() =>
              document.getElementById("enlist-section")?.scrollIntoView({ behavior: "smooth" })
            }
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-full font-medium transition"
          >
            Subscribe
          </button>
        </div>
        <div className="p-6 min-h-[240px]">
          <ul className="space-y-3 text-sm">
            {plan.features.map((item, i) => (
              <li key={i}>✅ {item}</li>
            ))}
          </ul>
        </div>
      </div>
    ))}
  </div>

  {/* Custom Contact Banner */}
<div className="mt-12 bg-blue-50 border border-blue-200 rounded-xl p-6 text-center">
  <h3 className="text-xl font-semibold text-blue-700 mb-2">Need something custom?</h3>
  <p className="text-sm text-blue-600 mb-4">
    Let’s talk about a tailored solution for your organization or enterprise.
  </p>
  <a
    href="https://wa.me/919773571992"
    target="_blank"
    rel="noopener noreferrer"
    className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-full font-medium transition inline-block"
  >
    Contact Sales
  </a>
</div>

</div>



  </div>
</div>
{/* <div id="enlist-section" className="scroll-mt-24">
  <EnlistYourInstitute />
</div> */}



      {/* Testimonials Section */}
      {/* <div className="container mx-auto px-6 py-16">
        <h2 className="text-3xl font-bold text-center mb-4">
          Voices of our customers
        </h2>
        <p className="text-center text-gray-600 mb-12">
          See how other successful RTOs have transformed their enrollment
          process with us
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
         
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center mr-4">
                <i className="fas fa-user text-gray-400"></i>
              </div>
              <div>
                <h4 className="font-bold">Carter Lewis</h4>
                <p className="text-sm text-gray-500">FlightAcademy</p>
              </div>
              <div className="ml-auto">
                <div className="flex">
                  {[1, 2, 3, 4].map((star) => (
                    <i key={star} className="fas fa-star text-yellow-400"></i>
                  ))}
                  <i className="fas fa-star text-gray-300"></i>
                </div>
              </div>
            </div>
            <div className="relative">
              <i className="fas fa-quote-left text-blue-100 text-4xl absolute -top-2 -left-1"></i>
              <p className="text-gray-700 relative z-10 pl-6">
                Since joining, our RPTO has seen a 65% increase in qualified
                student enrollments. The quality of leads has exceeded our
                expectations, making our growth predictable and sustainable.
              </p>
            </div>
          </div>

          
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center mr-4">
                <i className="fas fa-user text-gray-400"></i>
              </div>
              <div>
                <h4 className="font-bold">Cameron Parker</h4>
                <p className="text-sm text-gray-500">DroneX</p>
              </div>
              <div className="ml-auto">
                <div className="flex">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="fas fa-star text-yellow-400"></i>
                  ))}
                </div>
              </div>
            </div>
            <div className="relative">
              <i className="fas fa-quote-left text-blue-100 text-4xl absolute -top-2 -left-1"></i>
              <p className="text-gray-700 relative z-10 pl-6">
                The lead quality is outstanding. Over 40% of our leads convert
                to paying students, which has transformed how we approach our
                marketing and enrollment process.
              </p>
            </div>
          </div>

          
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center mr-4">
                <i className="fas fa-user text-gray-400"></i>
              </div>
              <div>
                <h4 className="font-bold">Morgan Taylor</h4>
                <p className="text-sm text-gray-500">SkyTech</p>
              </div>
              <div className="ml-auto">
                <div className="flex">
                  {[1, 2, 3, 4].map((star) => (
                    <i key={star} className="fas fa-star text-yellow-400"></i>
                  ))}
                  <i className="fas fa-star text-gray-300"></i>
                </div>
              </div>
            </div>
            <div className="relative">
              <i className="fas fa-quote-left text-blue-100 text-4xl absolute -top-2 -left-1"></i>
              <p className="text-gray-700 relative z-10 pl-6">
                As a growing RPTO, finding consistent quality leads was our
                biggest challenge. This subscription solved that problem
                completely, allowing us to focus on what we do best - training
                pilots.
              </p>
            </div>
          </div>

         
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center mr-4">
                <i className="fas fa-user text-gray-400"></i>
              </div>
              <div>
                <h4 className="font-bold">Alex Rodriguez</h4>
                <p className="text-sm text-gray-500">AeroSchool</p>
              </div>
              <div className="ml-auto">
                <div className="flex">
                  {[1, 2, 3, 4].map((star) => (
                    <i key={star} className="fas fa-star text-yellow-400"></i>
                  ))}
                  <i className="fas fa-star text-gray-300"></i>
                </div>
              </div>
            </div>
            <div className="relative">
              <i className="fas fa-quote-left text-blue-100 text-4xl absolute -top-2 -left-1"></i>
              <p className="text-gray-700 relative z-10 pl-6">
                Our RPTO experienced a 52% growth in just six months. The
                consistent flow of pre-qualified leads has allowed us to expand
                our operations with confidence.
              </p>
            </div>
          </div>

         
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center mr-4">
                <i className="fas fa-user text-gray-400"></i>
              </div>
              <div>
                <h4 className="font-bold">Jordan Lee</h4>
                <p className="text-sm text-gray-500">DroneAce</p>
              </div>
              <div className="ml-auto">
                <div className="flex">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="fas fa-star text-yellow-400"></i>
                  ))}
                </div>
              </div>
            </div>
            <div className="relative">
              <i className="fas fa-quote-left text-blue-100 text-4xl absolute -top-2 -left-1"></i>
              <p className="text-gray-700 relative z-10 pl-6">
                The quality of leads we receive has dramatically improved our
                conversion rates. We're now able to plan our growth strategy
                with much more certainty.
              </p>
            </div>
          </div>

        
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center mr-4">
                <i className="fas fa-user text-gray-400"></i>
              </div>
              <div>
                <h4 className="font-bold">Riley Wilson</h4>
                <p className="text-sm text-gray-500">SkyTraining</p>
              </div>
              <div className="ml-auto">
                <div className="flex">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="fas fa-star text-yellow-400"></i>
                  ))}
                </div>
              </div>
            </div>
            <div className="relative">
              <i className="fas fa-quote-left text-blue-100 text-4xl absolute -top-2 -left-1"></i>
              <p className="text-gray-700 relative z-10 pl-6">
                Before using this service, our enrollment process was
                unpredictable and stressful. Now we have a consistent pipeline
                of interested students that keeps our classes full.
              </p>
            </div>
          </div>
        </div>
      </div> */}

      {/* Footer CTA */}
      <div className="bg-blue-900 text-white py-16">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to grow your RPTO?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Join the leading RTOs nationwide who are transforming their
            enrollment process with our premium lead generation service.
          </p>
         <button
  onClick={() =>
    document.getElementById("enlist-section")?.scrollIntoView({ behavior: "smooth" })
  }
  className="
    bg-white
    border
    border-blue-700
    text-blue-700
    px-8 py-3
    rounded-md
    font-semibold
    hover:bg-blue-700
    hover:text-white
    transition
    duration-300
    cursor-pointer
    whitespace-nowrap
    focus:outline-none
    focus:ring-2
    focus:ring-blue-400
  "
>
  Start Your Subscription Today
</button>

        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default App;

